(function () {
  var CONSENT_KEY = 'verkline_cookie_consent_v1';
  var CONSENT_TTL = 365 * 24 * 60 * 60 * 1000;
  var BANNER_ID = 'verkline-cookie-banner';
  var PANEL_ID = 'verkline-cookie-panel';
  var OVERLAY_ID = 'verkline-cookie-panel-overlay';
  var DE_COUNTRIES = ['DE', 'AT', 'CH', 'LI'];
  // PBar upsell widget. Its iframe (#PBarNextFrame) plus its wrapper
  // (#PBarNextFrameWrapper) share the bottom strip of the page and stack
  // above the cookie banner actions via their own compositing layer, even
  // though the banner has z-index 999999. Taps land on PBar instead of
  // Accept/Reject so the consent handler never fires. We hide both while
  // the banner/panel are visible and restore their original inline styles
  // afterwards. Same pattern as the Google Merchant widget hide below.
  var PBAR_SELECTORS = ['#PBarNextFrame', '#PBarNextFrameWrapper'];
  // EU 27 + Iceland, Liechtenstein, Norway (EEA) + UK + Switzerland.
  // Banner is GDPR/UK GDPR-driven, so we show it only when the visitor is in a
  // jurisdiction that requires opt-in consent. All other countries (AU, US,
  // Asia, etc.) are fail-closed: no banner shown.
  var EU_UK_COUNTRIES = [
    'AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR',
    'DE','GR','HU','IE','IT','LV','LT','LU','MT','NL',
    'PL','PT','RO','SK','SI','ES','SE',
    'IS','LI','NO','GB','CH'
  ];

  function readConsent() {
    try {
      var raw = localStorage.getItem(CONSENT_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.ts) return null;
      if (Date.now() - parsed.ts > CONSENT_TTL) return null;
      return parsed;
    } catch (e) {
      return null;
    }
  }

  function writeConsent(data) {
    try {
      var toStore;
      if (typeof data === 'boolean') {
        toStore = {
          analytics: data,
          marketing: data,
          preferences: data,
          sale_of_data: data,
          ts: Date.now()
        };
      } else {
        toStore = {
          analytics: !!data.analytics,
          marketing: !!data.marketing,
          preferences: !!data.preferences,
          sale_of_data: !!data.sale_of_data,
          ts: Date.now()
        };
      }
      localStorage.setItem(CONSENT_KEY, JSON.stringify(toStore));
    } catch (e) {}
  }

  function pickLocale(country) {
    if (country === 'PL') return 'pl';
    if (DE_COUNTRIES.indexOf(country) !== -1) return 'de';
    return 'en';
  }

  function getDict(locale) {
    return (window.VERKLINE_CB_TRANSLATIONS || {})[locale] ||
           (window.VERKLINE_CB_TRANSLATIONS || {}).en ||
           null;
  }

  function applyTranslations(locale) {
    var banner = document.getElementById(BANNER_ID);
    var panel = document.getElementById(PANEL_ID);
    var dict = getDict(locale);
    if (!dict) return;

    if (banner) {
      var titleEl = banner.querySelector('[data-vcb-title]');
      if (titleEl) titleEl.textContent = dict.title;

      var bodyEl = banner.querySelector('[data-vcb-body]');
      if (bodyEl) bodyEl.innerHTML = dict.body;

      var setText = function (root, sel, txt) {
        var el = root.querySelector(sel);
        if (el && typeof txt === 'string') el.textContent = txt;
      };

      setText(banner, '[data-vcb-action="accept"]', dict.accept);
      setText(banner, '[data-vcb-action="reject"]', dict.reject);
      setText(banner, '[data-vcb-action="manage"]', dict.manage);

      banner.setAttribute('lang', locale);
      banner.setAttribute('data-vcb-locale', locale);
    }

    if (panel && dict.panel) {
      var p = dict.panel;
      var setPanel = function (sel, txt) {
        var el = panel.querySelector(sel);
        if (el && typeof txt === 'string') el.textContent = txt;
      };

      setPanel('[data-vcb-panel-title]', p.title);
      setPanel('[data-vcb-panel-subtitle]', p.subtitle);

      setPanel('[data-vcb-cat-name="essential"]', p.essential_name);
      setPanel('[data-vcb-cat-desc="essential"]', p.essential_desc);
      setPanel('[data-vcb-cat-name="preferences"]', p.preferences_name);
      setPanel('[data-vcb-cat-desc="preferences"]', p.preferences_desc);
      setPanel('[data-vcb-cat-name="marketing"]', p.marketing_name);
      setPanel('[data-vcb-cat-desc="marketing"]', p.marketing_desc);
      setPanel('[data-vcb-cat-name="analytics"]', p.analytics_name);
      setPanel('[data-vcb-cat-desc="analytics"]', p.analytics_desc);

      setPanel('[data-vcb-action="save"]', p.save);

      var closeBtn = panel.querySelector('[data-vcb-action="panel-close"]');
      if (closeBtn && p.close) closeBtn.setAttribute('aria-label', p.close);

      panel.setAttribute('lang', locale);
    }
  }

  function hidePBar() {
    PBAR_SELECTORS.forEach(function (sel) {
      var el = document.querySelector(sel);
      if (!el) return;
      if (el.dataset.vcbHidden) return; // already hidden by us, don't overwrite prev-values
      el.dataset.vcbHidden = '1';
      el.dataset.vcbPrevVis = el.style.visibility || '';
      el.dataset.vcbPrevPe = el.style.pointerEvents || '';
      el.style.visibility = 'hidden';
      // pointer-events:none is a second line of defense. iframes with their
      // own compositing layer don't always honor visibility:hidden for
      // hit-testing in Chrome, so we also disable pointer interactions.
      el.style.pointerEvents = 'none';
    });
  }

  function restorePBar() {
    PBAR_SELECTORS.forEach(function (sel) {
      var el = document.querySelector(sel);
      if (!el || !el.dataset.vcbHidden) return;
      el.style.visibility = el.dataset.vcbPrevVis || '';
      el.style.pointerEvents = el.dataset.vcbPrevPe || '';
      delete el.dataset.vcbHidden;
      delete el.dataset.vcbPrevVis;
      delete el.dataset.vcbPrevPe;
    });
  }

  function showBanner() {
    var banner = document.getElementById(BANNER_ID);
    if (!banner) return;
    // Hide Google Merchant Reviews widget while banner is visible.
    // Its iframe z-index (2147483647) overlaps the Accept button on mobile
    // (<= 520 px viewports), blocking clicks. We use visibility:hidden (not
    // display:none) to preserve the widget's internal state.
    var gm = document.getElementById('google-merchantwidget-iframe-wrapper');
    if (gm) {
      gm.dataset.vcbHidden = '1';
      gm.style.visibility = 'hidden';
    }
    hidePBar();
    banner.hidden = false;
    requestAnimationFrame(function () {
      banner.classList.add('is-visible');
    });
  }

  function hideBanner() {
    var banner = document.getElementById(BANNER_ID);
    if (!banner) return;
    banner.classList.remove('is-visible');
    setTimeout(function () {
      banner.hidden = true;
      // Only restore PBar if the panel is also closed. User may have
      // tapped Manage: panel opens, banner hides, but PBar should stay
      // hidden until the panel closes too.
      var panel = document.getElementById(PANEL_ID);
      if (!panel || panel.hidden) restorePBar();
    }, 300);
    // Restore Google Merchant widget only if we were the one hiding it.
    var gm = document.getElementById('google-merchantwidget-iframe-wrapper');
    if (gm && gm.dataset.vcbHidden) {
      gm.style.visibility = '';
      delete gm.dataset.vcbHidden;
    }
  }

  function showPanel() {
    var panel = document.getElementById(PANEL_ID);
    var overlay = document.getElementById(OVERLAY_ID);
    if (!panel) return;

    // Pre-fill checkboxes with existing consent if any
    var existing = readConsent();
    var catMap = {
      preferences: 'vcb-cat-preferences',
      marketing: 'vcb-cat-marketing',
      analytics: 'vcb-cat-analytics'
    };
    Object.keys(catMap).forEach(function (k) {
      var el = document.getElementById(catMap[k]);
      if (!el) return;
      el.checked = existing ? !!existing[k] : false;
    });

    // Defense-in-depth: the panel has its own fullscreen overlay, but we
    // still hide PBar in case the user reached showPanel without going
    // through showBanner first (future entry points, deep links, etc.).
    hidePBar();
    panel.hidden = false;
    if (overlay) overlay.hidden = false;
    requestAnimationFrame(function () {
      panel.classList.add('is-visible');
      if (overlay) overlay.classList.add('is-visible');
    });
    document.body.style.overflow = 'hidden';
  }

  function hidePanel() {
    var panel = document.getElementById(PANEL_ID);
    var overlay = document.getElementById(OVERLAY_ID);
    if (!panel) return;
    panel.classList.remove('is-visible');
    if (overlay) overlay.classList.remove('is-visible');
    setTimeout(function () {
      panel.hidden = true;
      if (overlay) overlay.hidden = true;
      // Only restore PBar if the banner is also closed. panel-close goes
      // back to the banner (which is still visible behind), so in that
      // case we keep PBar hidden.
      var banner = document.getElementById(BANNER_ID);
      if (!banner || banner.hidden) restorePBar();
    }, 300);
    document.body.style.overflow = '';
  }

  function setShopifyConsent(consent) {
    try {
      if (
        window.Shopify &&
        window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function'
      ) {
        window.Shopify.customerPrivacy.setTrackingConsent(
          consent,
          function (err) {
            if (err) console.warn('[Verkline CB] consent error', err);
          }
        );
        return;
      }
    } catch (e) {
      console.warn('[Verkline CB] shopify api unavailable', e);
    }
  }

  function saveGranular() {
    var preferences = !!document.getElementById('vcb-cat-preferences') && document.getElementById('vcb-cat-preferences').checked;
    var marketing = !!document.getElementById('vcb-cat-marketing') && document.getElementById('vcb-cat-marketing').checked;
    var analytics = !!document.getElementById('vcb-cat-analytics') && document.getElementById('vcb-cat-analytics').checked;

    var consent = {
      analytics: analytics,
      marketing: marketing,
      preferences: preferences,
      sale_of_data: marketing
    };

    setShopifyConsent(consent);
    writeConsent(consent);

    hidePanel();
    hideBanner();

    document.dispatchEvent(
      new CustomEvent('verkline:cookie-consent', {
        detail: { action: 'save', consent: consent }
      })
    );
  }

  function handleAction(action) {
    if (action === 'manage') {
      showPanel();
      return;
    }
    if (action === 'panel-close') {
      hidePanel();
      return;
    }
    if (action === 'save') {
      saveGranular();
      return;
    }

    if (action === 'accept') {
      var allYes = {
        analytics: true,
        marketing: true,
        preferences: true,
        sale_of_data: true
      };
      setShopifyConsent(allYes);
      writeConsent(true);
    } else if (action === 'reject') {
      var allNo = {
        analytics: false,
        marketing: false,
        preferences: false,
        sale_of_data: false
      };
      setShopifyConsent(allNo);
      writeConsent(false);
    }
    hideBanner();
    document.dispatchEvent(
      new CustomEvent('verkline:cookie-consent', {
        detail: { action: action }
      })
    );
  }

  function bindEvents() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-vcb-action]');
      if (!btn) return;
      e.preventDefault();
      handleAction(btn.getAttribute('data-vcb-action'));
    });

    // Close panel on overlay click
    var overlay = document.getElementById(OVERLAY_ID);
    if (overlay) {
      overlay.addEventListener('click', function () {
        hidePanel();
      });
    }

    // Close panel on Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        var panel = document.getElementById(PANEL_ID);
        if (panel && !panel.hidden) hidePanel();
      }
    });
  }

  function reapplyExistingConsent() {
    var existing = readConsent();
    if (!existing) return false;
    setShopifyConsent({
      analytics: !!existing.analytics,
      marketing: !!existing.marketing,
      preferences: !!existing.preferences,
      sale_of_data: !!existing.sale_of_data
    });
    return true;
  }

  function init() {
    if (reapplyExistingConsent()) return;

    var fallbackLocale = (document.documentElement.getAttribute('lang') || 'en')
      .slice(0, 2)
      .toLowerCase();
    if (['pl', 'de', 'en'].indexOf(fallbackLocale) === -1) fallbackLocale = 'en';

    var shown = false;
    var showWithLocale = function (loc) {
      if (shown) return;
      shown = true;
      applyTranslations(loc);
      showBanner();
    };

    // Fail-closed fallback: only Polish and German visitors see a banner if
    // Cloudflare geo fails. English speakers worldwide (AU, US, Asia, ...)
    // do NOT get a banner unless geo resolves to an EU/UK country.
    var timeoutFallback = setTimeout(function () {
      if (['pl', 'de'].indexOf(fallbackLocale) !== -1) {
        showWithLocale(fallbackLocale);
      }
    }, 1200);

    fetch('/cdn-cgi/trace', { cache: 'no-store' })
      .then(function (r) {
        return r.text();
      })
      .then(function (d) {
        clearTimeout(timeoutFallback);
        var m = d.match(/loc=([A-Z]{2})/);
        var country = m ? m[1] : null;
        // Show banner only for EU/EEA/UK/CH visitors (GDPR/UK GDPR scope).
        // Everyone else (including AU, US, Asia) gets no banner.
        if (country && EU_UK_COUNTRIES.indexOf(country) !== -1) {
          showWithLocale(pickLocale(country));
        }
      })
      .catch(function () {
        clearTimeout(timeoutFallback);
        if (['pl', 'de'].indexOf(fallbackLocale) !== -1) {
          showWithLocale(fallbackLocale);
        }
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindEvents();
      init();
    });
  } else {
    bindEvents();
    init();
  }
})();
